import styled from 'foundations-theming/utils';
import { ONBOARDING_COLOR } from './colors';
export const TourButtonLabel = styled.div.withConfig({
  displayName: "styles__TourButtonLabel"
})([".hs-private.hs-private.hs-private &{font-family:", ";font-size:", ";font-weight:", ";color:", ";}"], ({
  theme
}) => theme.typography['body-600'].fontFamily, ({
  theme
}) => theme.typography['detail-100'].fontSize, ({
  theme
}) => theme.typography['body-125'].fontWeight, ({
  theme
}) => theme.color[ONBOARDING_COLOR]);